import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import storage from 'helpers/storage';
import update from 'react-addons-update';
import ReactTable from 'react-table';
import scroll from 'helpers/scroll';
import cm from 'helpers/commons';
import { Popup } from 'semantic-ui-react';
import { Commons } from 'components';

import * as cm_action from 'actions/commons';

class MealApproveAccepterResult extends Component {
  state = {
    tempUser: null,
    param: {
      keyword: null,
      orgCode: null,
      groupid: null,
      viewType: 'all'
    },
    elements: [],
    headers: [],
    heightIdx: 0,
    containerHeight: 620,
    isInfiniteLoading: false,
    isChecked: false,
    staffCheckedData: [],
    isLoadingBar: false
  };

  componentWillMount() {
    const { checkInput } = this.props;

    if (checkInput) {
      this.setState({
        headers: [
          { header: '', width: 56, isChecked: true, className: 'allCheckbox' },
          { header: 'ID', width: 200, clickAction: true },
          { header: '이름', width: 116 },
          { header: '직위', width: 120 },
          { header: '직책', width: 120 },
          { header: '사번', width: 120 },
          { header: '권한', width: 88 }
        ]
      });
    } else {
      this.setState({
        headers: [
          { header: 'ID', width: 200, clickAction: true },
          { header: '이름', width: 116 },
          { header: '직위', width: 120 },
          { header: '직책', width: 120 },
          { header: '사번', width: 120 },
          { header: '권한', width: 88 }
        ]
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      staffCheckedData: nCheckData,
      approveAccepterList: nApproveAccepterList,
      searchKeyword: nSearchKeyword
    } = nextProps;
    const { staffCheckedData } = this.state;
    const { approveAccepterList, searchKeyword } = this.props;
    const approveAccepterListChange = JSON.stringify(approveAccepterList) !== JSON.stringify(nApproveAccepterList);
    const changeKeyword = searchKeyword !== nSearchKeyword;
    if (approveAccepterListChange || changeKeyword) {
      this.scrollEvent(nextProps.approveAccepterList);
      this.setState({
        staffCheckedData: []
      });
    }
  }

  scrollEvent = (approveAccepterList) => {
    if (approveAccepterList && approveAccepterList.data) {
      const { isModal } = this.props;
      const { accepters, user } = approveAccepterList.data;
      const data = isModal ? user : accepters;
      let count = data ? (data.length > 100 ? 100 : data.length) : 0;
      this.setState({
        elements: this.buildElements(0, count, data, false),
        isInfiniteLoading: false
      });
    } else {
      this.setState({ elements: [] });
    }
  };

  isLoadingBarChange = async (isShow) => {
    await this.setState({ isLoadingBar: isShow });
  };

  handleInfiniteLoad = async () => {
    const { approveAccepterList } = this.props;
    const { elements, heightIdx, containerHeight } = this.state;
    const item = approveAccepterList ? (approveAccepterList.data || {}).paging : null;
    let that = this;
    let elemLength = elements.length;
    let itemLength = item ? item.totalcount : 0;
    const infiniteParm = scroll.event(null, elements, containerHeight, heightIdx, elemLength);
    const params = {};

    if (elemLength < itemLength) {
      if (this.props.params) {
        params['keyword'] = this.props.params.keyword;
        params['orgCode'] = this.props.params.orgCode;
        params['auth'] = this.props.params.auth;
        params['groupid'] = this.props.params.groupid;
      }

      this.setState({
        isInfiniteLoading: true,
        heightIdx: heightIdx + containerHeight
      });

      const { isModal, approveAccepterList } = this.props;
      let data = null;
      if (approveAccepterList) {
        const { accepters, user } = approveAccepterList.data;
        data = isModal ? user : accepters;
      }
      let elementsData = this.buildElements(elemLength, elemLength + 100, data, false);

      setTimeout(function() {
        that.setState({
          elements: that.state.elements.concat(elementsData),
          heightIdx: infiniteParm.heightIdx,
          isInfiniteLoading: false
        });
      }, 500);
    } else {
      // this.setState({
      //   isInfiniteLoading : false
      // })
    }
  };

  buildElements = (start, end, item) => {
    try {
      let elements = [];
      if (item) {
        const data = item;
        for (let i = start; i < item.length; i++) {
          const temp = this.listItem(data[i]);
          if (temp) {
            elements.push(temp);
          }
        }
      }
      return elements;
    } catch (e) {
      console.log('###### e : ', e);
    }
  };

  listItem = (item) => {
    const { staffChecked, modalStaffChecked } = this;
    const { headers } = this.state;
    const { isModal, acceptersMap, checkInput, keyword } = this.props;

    let isDisabled = false;
    let checked = null;
    let result = null;
    let staffCheckbox = 'staff-checkbox';
    if (!item) return;

    if (item) {
      if (isModal && acceptersMap && acceptersMap.get(item.id)) {
        isDisabled = true;
        checked = true;
        staffCheckbox = '';
      }
      if (item.status === 'INACTIVE') {
        isDisabled = true;
        checked = false;
      }
      const division = cm.trTdDivision(item.orgCode);
      let styles = [];
      headers.forEach((headerItem, index) => {
        styles.push({
          flex: `0 0 ${headerItem.width}`,
          width: headerItem.width,
          maxWidth: headerItem.width,
          padding: '10px 5px'
        });
      });
      let dimStyle = null;
      if (isDisabled) {
        dimStyle = 'rgba(238, 238, 238, 0.28)';
      }

      let num = null;

      if (!checkInput) {
        num = 0;
      } else {
        num = 1;
      }
      const word = keyword ? keyword.value : '';
      if (word) {
        if (item.name && item.name.indexOf(word) === -1 && item.signId && item.signId.indexOf(word) === -1) {
          return null;
        }
      }

      result = (
        <div
          className="rt-tr -odd"
          key={item.id}
          style={{
            width: '100%',
            backgroundColor: dimStyle
          }}
        >
          {checkInput ? (
            <div className="rt-td" style={styles[0]}>
              <div className="checkbox pure">
                <label>
                  <input
                    type="checkbox"
                    id={item.id}
                    name={item.name}
                    checked={checked}
                    disabled={isDisabled}
                    className={`${staffCheckbox} ${item.signid}`}
                    value="on"
                    onClick={(e) => (isModal ? modalStaffChecked(e, item, null) : staffChecked(e, item, null))}
                  />
                  <span />
                </label>
              </div>
            </div>
          ) : null}
          <div className="rt-td" style={styles[0 + num]}>
            {isModal ? item.signid : item.signId}
          </div>
          <div className="rt-td" style={styles[1 + num]}>
            {item.name}
          </div>
          {division.map((divi, i) => {
            return (
              <div key={`divi${i}`} className="rt-td" style={{ flex: '0 0 128px' }}>
                <Popup className="td-tooltip" inverted trigger={<span>{divi}</span>} content={divi} />
              </div>
            );
          })}
          <div className="rt-td" style={styles[2 + num]}>
            {item.position}
          </div>
          <div className="rt-td" style={styles[3 + num]}>
            {item.rankposition}
          </div>
          <div className="rt-td" style={styles[4 + num]}>
            {item.comidnum}
          </div>
          <div className="rt-td" style={styles[5 + num]}>
            {cm.newTypeName(item.grade.code)}
          </div>
        </div>
      );

      return result;
    } else {
      return null;
    }
  };

  scrollHandler = (e) => {
    const { isModal, accepterChecked } = this.props;
    const { staffCheckedData } = this.state;
    const data = isModal ? accepterChecked : staffCheckedData;

    data.forEach((item) => {
      const dom = $('#' + item.id);
      if (dom.is(':disabled')) return;
      dom.prop('checked', true);
    });
  };

  tBodyFunc = (state) => {
    const { elements, containerHeight, isInfiniteLoading } = this.state;
    const { isModal, accepter, empty } = this.props;
    return (
      <div className="rt-tbody" style={state.style}>
        <div className="rt-tr-group">
          <Infinite
            className="infinite-scroll"
            elementHeight={43}
            containerHeight={containerHeight}
            infiniteLoadBeginEdgeOffset={containerHeight - 50}
            onInfiniteLoad={this.handleInfiniteLoad}
            isInfiniteLoading={isInfiniteLoading}
            handleScroll={this.scrollHandler}
          >
            {empty ? <div className="rt-noData" /> : accepter !== 'ALL' && elements}
          </Infinite>
        </div>
      </div>
    );
  };

  // 데이터가 없을 때
  noDataProps = (state) => {
    const { isModal, approveAccepterList, accepter } = this.props;
    let dom = <div className="rt-noData">검색 결과가 없습니다.</div>;

    if (approveAccepterList && approveAccepterList.data) {
      const { accepters, user } = approveAccepterList.data;

      const data = isModal ? user : accepters;
      if (data) {
        dom = <div className="rt-noData" />;
      }
    }

    if (accepter === 'ALL') {
      dom = <div className="rt-noData">모든 사용자가 식권 승인 대상자로 지정될 수 있습니다.</div>;
    }

    return dom;
  };

  //사용자 체크박스 선택 on/off
  staffChecked = async (e, data, type) => {
    let isChecked = e.target.checked;
    let events = e.target;

    //전체 선택 on/off
    if (type === 'all') {
      this.isLoadingBarChange(true);
      const { isModal, approveAccepterList, checkAccepterId } = this.props;
      let data = null;
      if (approveAccepterList) {
        data = isModal ? approveAccepterList.data.user : approveAccepterList.data.accepters;
      }
      // 전체 on/off 된 데이터 반환
      const staffCheckedData = cm.staffCheckedData(e, data, isChecked, 'all');
      await this.setState({
        isChecked: isChecked,
        staffCheckedData: staffCheckedData
      });

      // 체크된 사용자 ID를 넘김
      checkAccepterId(staffCheckedData);
      this.isLoadingBarChange(false);

      $('.staff-checkbox').prop('checked', isChecked);
    } else {
      await this.setState((prevState, props) => {
        return {
          staffCheckedData: cm.staffCheckedData(events, prevState.staffCheckedData, isChecked, 'each')
        };
      });

      // 체크된 사용자 ID를 넘김
      const { staffCheckedData } = this.state;
      const { checkAccepterId } = this.props;

      checkAccepterId(staffCheckedData);
    }
  };

  //accepter 데이터 set
  accepterUserSet = (item) => {
    const { acceptersMap } = this.props;

    if (item.status === 'INACTIVE') return;
    else if (acceptersMap && acceptersMap.get(item.id)) return;

    return {
      id: item.id,
      signId: item.signid,
      name: item.name,
      orgCode: item.orgCode,
      rankposition: item.rankposition,
      position: item.position,
      comidnum: item.comidnum,
      status: item.status,
      grade: item.grade
    };
  };

  // modal 체크박스 선택 func
  modalStaffChecked = async (e, item, type) => {
    const { handleAccepterChecked, approveAccepterList } = this.props;
    if (!approveAccepterList || !approveAccepterList.data) return;

    let isChecked = e.target.checked;

    if (type === 'all') {
      const { user } = approveAccepterList.data;
      const set = [];
      user.forEach((item) => {
        const accepter = this.accepterUserSet(item);
        if (accepter) {
          set.push(accepter);
        }
      });
      handleAccepterChecked('all', isChecked, set);
      $('.staff-checkbox').prop('checked', isChecked);
    } else {
      const accepter = this.accepterUserSet(item);
      handleAccepterChecked('one', isChecked, accepter);
    }
  };

  render() {
    const { isModal, checkInput } = this.props;
    const { headers } = this.state;
    let header;
    if (checkInput) {
      header = cm.tableHeaderList(headers, 3, null, null, null, true);
    } else {
      header = cm.tableHeaderList(headers, 2, null, null, null, true);
    }
    const fn = {
      fnChecked: isModal ? this.modalStaffChecked : this.staffChecked,
      move: null
    };
    const columns = scroll.header(header, fn);

    return (
      <div className="reject-modal">
        <ReactTable
          className="react-table"
          columns={columns}
          sortable={false}
          resizable={false}
          showPagination={false}
          TbodyComponent={this.tBodyFunc}
          NoDataComponent={this.noDataProps}
        />
      </div>
    );
  }
}

MealApproveAccepterResult = connect(
  (state) => ({
    keyword: state.commons.text
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        staffSel: cm_action.StaffSel
      },
      dispatch
    )
  })
)(MealApproveAccepterResult);

export default MealApproveAccepterResult;
